<template>
    <v-app id="inspire">
        <v-navigation-drawer persistent v-model="drawer" enable-resize-watcher app>
            <SideBar></SideBar>
        </v-navigation-drawer>
        <v-toolbar app fixed>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title>Grandiz!</v-toolbar-title>
        </v-toolbar>
        <main>
            <v-content>
                <router-view></router-view>
            </v-content>
        </main>
        <v-footer app fixed>
            <span>&copy; 2017</span>
        </v-footer>
    </v-app>
</template>


<script>

    import SideBar from './SideBar.vue'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                drawer: false
            }
        },
        components: {
            SideBar
        },
        methods: {
            auth() {
            }
        }
    }
</script>

<style scoped>
    h1,
    h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .main {
        width: 1100px;
        margin: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Admin/Components/MainTemplate.vue